<template>
  <div>
    <!-- <p class="c-inner-title">文本</p> -->
    <div class="auto">
      <page-title title="文本" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" size="small" @click="addHandle()">添加素材</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input v-model="filter.search" size="small" clearable class="m-lr-5" style="width:200px;" placeholder="请输入内容搜索"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
              <el-button type="primary" size="small" @click="handleChangeFilter()">搜索</el-button>
            </el-col>
          </el-row>
          <el-row v-loading="loading">
            <el-col :span="24" class="masonry">
              <div class="list-box" v-for="(item, index) in tableData" :key="index">
                <div class="texttitle gray80">
                  {{item.remark}}
                </div>
                <div v-html="item.content && item.content.replace(/\n/g, '<br>').replace(/  /g, '&nbsp;&nbsp;')" class="textbox local_text gray80"></div>
                <div class="control">
                  <span class="gray80">
                    {{item.create_time.split(' ')[0]}}
                  </span>
                  <el-tooltip class="item" effect="dark" content="正在使用中的素材无法进行编辑、删除，如需修改请先将素材取消使用" v-show="item.is_use" placement="top" style="float:right;margin-left:10px;margin-top:2px;">
                    <i class="fa fa-question-circle-o gray80"></i>
                  </el-tooltip>
                  <a href="javascript:;" @click="deleteNewsHandle(index)" class="colorred" v-show="!item.is_use">删除</a>
                  <a href="javascript:;" @click="editHandle(item, false)" v-show="!item.is_use">编辑</a>
                  <a href="javascript:;" @click="editHandle(item, true)">预览</a>
                  <a href="javascript:;" @click="testHandle(item)">测试</a>
                </div>
              </div>
            </el-col>
          </el-row>
          <div v-if="count > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="文本素材" :visible.sync="dialogVisible" :before-close="handleClose" v-loading="submitloading" class="replyDialog" width="1000px">
      <el-row>
        <el-col :span="24">
          <el-form ref="remarkform" :model="remark" :rules="remarkrules" label-width="80px">
            <el-form-item label="" prop="">
            </el-form-item>
            <el-form-item label="标题" prop="remark">
              <el-input v-model.trim="remark.remark"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form ref="form" :model="current" :rules="rules" label-width="80px">
            <!-- <el-form-item label="标题" prop="title">
              <el-input v-model.trim="current.title"></el-input>
            </el-form-item> -->
            <el-form-item label="内容" prop="content" style="position: relative;" id="contentinput">
              <el-input type="textarea" ref="content" class="contentinput" :readonly="isPreview" :rows="4" v-model="current.content"></el-input>
              <div class="previewbox boxsizing mpreplytext" v-html="current.content.replace(/\n/g, '<br>').replace(/  /g, '&nbsp;&nbsp;')"></div>
              <div class="title title1">编辑区</div>
              <div class="title title2">预览区</div>
              <div class="tips" @click="tipsclick" v-show="current.content === ''">
                使用指南：<br>
                1.请自由的输入文字<br>
                2.支持回车换行<br>
                3.插入文字链接请点击下方按钮，并在插入的链接模板中替换跳转链接及跳转文字<br>
                <!-- 按照&lt;a href='这里输入跳转链接'>这里输入显示文字&lt;/a>的格式录入 -->
                4.可在右侧实时预览效果
              </div>
            </el-form-item>
            <el-form-item label="" v-show="!isPreview">
              <el-button @click="openlink" size="small" style="float:left;">插入链接</el-button>
              <el-button @click="openminilink" size="small" style="float:left;">插入小程序链接</el-button>
              <span class="font12" style="display:block;clear:both;color:#F56C6C;padding-top: 15px;">
                Tips：为确保文字链接的正常使用，请不要修改示例中除文字及链接外的任何符号和内容。<br />
                如果此素材是用于京东平台推送，请填写原始链接在素材内，切勿将原始链接替换成荧识跳转链接，<br />
                京东平台在推送时，会自动将原始链接替换为特殊的跳转链接。</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" v-show="!isPreview">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加链接" :visible.sync="linkVisible" :before-close="handleLinkClose" class="replyDialog" width="60%">
      <el-row>
        <el-col :span="24">
          <el-form ref="formlink" :model="link" :rules="ruleslink" label-width="80px">
            <el-form-item label="" prop="">
            </el-form-item>
            <el-form-item label="文字" prop="title">
              <el-input v-model.trim="link.title"></el-input>
            </el-form-item>
            <el-form-item label="跳转地址" prop="link">
              <el-input v-model.trim="link.link"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLinkClose">取 消</el-button>
        <el-button type="primary" @click="handleLinkSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="测试" :modal-append-to-body="false" :visible.sync="testVisible" @close="handleTestClose" width="600px">
      <el-form ref="testText" :rules="testrules" :model="test" label-width="90px" size="small" v-loading="btnLoading">
        <el-form-item prop="openid" label="openid">
          <el-input type="text" v-model.trim="test.openid" placeholder="请输入测试用户的openid"></el-input>
        </el-form-item>
        <el-form-item prop="" label="">
          <p class="font12 gray80" style="line-height: 20px;">tips:测试用户的openid可以在 "用户"=>"详情" 中搜索微信昵称等方式获取,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;测试用户必须48小时内与公众号产生过互动(如发送消息、点击自定义菜单等)</p>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="primary" @click="handleTest">确定</el-button>
        <el-button @click="handleTestClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import VueCookie from 'vue-cookie'
import { Mp } from '@/model'
export default {
  data () {
    return {
      currentId: '',
      loading: false,
      submitloading: false,
      tableData: [],
      dialogVisible: false,
      linkVisible: false,
      current: {
        content: ''
      },
      rules: {
        content: [
          { required: true, message: '请填写内容', trigger: 'blur' }
        ]
      },
      link: {
        title: '',
        link: ''
      },
      ruleslink: {
        title: [
          { required: true, message: '请填写文字', trigger: 'blur' }
        ],
        link: [
          { required: true, message: '请填写跳转地址', trigger: 'blur' }
        ]
      },
      remark: {
        remark: ''
      },
      remarkrules: {
        remark: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ]
      },
      isEdit: false,
      positionStart: '',
      positionEnd: '',
      isPreview: false,
      fileList: [],
      filter: {
        type: 'local_text',
        search: '',
        page: '1',
        limit: '20'
      },
      count: 0,
      btnLoading: false,
      testVisible: false,
      test: {
        openid: '',
        type: '',
        id: ''
      },
      testrules: {
        openid: [
          { required: true, message: 'openid不能为空！', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    '$route': function (val) {
      this.queryToFilter()
    }
  },
  methods: {
    handleTest () {
      this.$refs['testText'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          let res = await Mp.Reply.previewMessage(this.test)
          if (res && !res['err_code']) {
            this.$message.success('测试信息已发出，请注意查收！')
          } else {
            this.$message.error(res.err_msg)
          }
          this.btnLoading = false
        }
      })
    },
    handleTestClose () {
      this.test = {
        id: '',
        openid: '',
        type: ''
      }
      this.testVisible = false
    },
    testHandle (item) {
      this.test = {
        id: item.id,
        openid: '',
        type: item.type
      }
      this.testVisible = true
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        type: 'local_text',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/reply/text', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    tipsclick () {
      this.$refs['content'].$refs['textarea'].focus()
    },
    editHandle (item, status) {
      this.isPreview = status
      this.isEdit = true
      this.currentId = item.id
      this.current.content = item.content
      this.remark.remark = item.remark
      this.dialogVisible = true
    },
    openlink () {
      this.positionStart = this.$refs['content'].$refs['textarea'].selectionStart
      this.positionEnd = this.$refs['content'].$refs['textarea'].selectionEnd
      var linkstr = '<a href=\'这里写跳转链接\'>这里输入显示文字</a>'
      this.current.content = this.current.content.substring(0, this.positionStart) + linkstr + this.current.content.substring(this.positionEnd, this.current.content.length)
      // this.linkVisible = true
    },
    openminilink () {
      this.positionStart = this.$refs['content'].$refs['textarea'].selectionStart
      this.positionEnd = this.$refs['content'].$refs['textarea'].selectionEnd
      var linkstr = '<a href=\'\' data-miniprogram-appid=\'这里写小程序APPID\' data-miniprogram-path=\'这里写小程序页面地址\'>这里输入显示文字</a>'
      this.current.content = this.current.content.substring(0, this.positionStart) + linkstr + this.current.content.substring(this.positionEnd, this.current.content.length)
      // this.linkVisible = true
    },
    handleLinkClose () {
      this.link = {
        title: '',
        link: ''
      }
      this.linkVisible = false
      this.$refs['formlink'].resetFields()
    },
    handleLinkSubmit () {
      this.$refs['formlink'].validate((valid) => {
        if (valid) {
          var linkstr = '<a href=\'' + this.link.link + '\'>' + '</a>'
          this.current.content = this.current.content.substring(0, this.positionStart) + linkstr + this.current.content.substring(this.positionEnd, this.current.content.length)
          this.handleLinkClose()
        }
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.resetForm()
    },
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$refs['remarkform'].validate((valid) => {
            if (valid) {
              this.saveLocalMaterialInfo()
            }
          })
        }
      })
    },
    async saveLocalMaterialInfo () {
      var content = this.current.content
      this.submitloading = true
      let res = await Mp.Reply.saveLocalMaterialInfo({
        id: this.isEdit ? this.currentId : '',
        // title: this.current.title,
        type: this.filter.type,
        content: content,
        remark: this.remark.remark
      })
      if (res.err_code === 0) {
        this.$message.success('提交成功')
        this.handleClose()
        this.resetFilter()
        this.getList()
      } else {
        this.$message.error(res.err_msg)
      }
      this.submitloading = false
    },
    resetForm () {
      this.currentId = ''
      this.current = {
        // title: '',
        content: ''
      }
      this.remark = {
        remark: ''
      }
      this.$refs['form'].resetFields()
      this.$refs['remarkform'].resetFields()
      this.isEdit = false
    },
    async getList () {
      this.loading = true
      let res = await Mp.Reply.getMaterialLocalList(this.filter)
      this.tableData = res['data']['list']
      this.count = res['data']['total']
      this.loading = false
    },
    addHandle () {
      this.dialogVisible = true
      this.isPreview = false
    },
    deleteNewsHandle (index) {
      this.$confirm('确定要删除此条内容吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteNewsFn(index)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async deleteNewsFn (index) {
      this.loading = true
      let res = await Mp.Reply.delLocalMaterial({type: this.filter.type, id: this.tableData[index].id})
      if (res.err_code === 0) {
        this.$message.success('删除成功')
        this.getList()
      } else {
        this.$message.error(res.err_msg)
        this.loading = false
      }
    }
  },
  created () {
    this.queryToFilter()
  }
}
</script>

<style scoped>
.masonry {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.list-box {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 5px;
  border: 1px solid #eee;
  float: left;
  height: auto;
  overflow: hidden;
  margin: 5px 0;
}
@media (min-width: 600px) {
  .list-box {
    width: calc(30% - 22px);
    margin-right: 3%;
  }
}
@media (min-width: 1200px) {
  .list-box {
    width: calc(22% - 22px);
    margin-right: 3%;
  }
}
@media (min-width: 1600px) {
  .list-box {
    width: calc(17% - 22px);
    margin-right: 3%;
  }
}
.texttitle {
  line-height: 20px;
  border-bottom: 1px solid #eee;
  padding: 5px 0 10px;
}
.textbox {
  line-height: 20px;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.textbox a {
  color: #50bfff;
}
.listbox-top {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  position: relative;
}
.listbox-top dl dt {
  font-size: 16px;
}
.noposter dd {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.hasposterBox {
  position: relative;
  height: auto;
  overflow: hidden;
}
.hasposter {
  position: relative;
}
.hasposter dt {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px 5%;
  background: rgba(0,0,0,.55);
  color: #fff;
  width: 90%;
}
.hasposter dd {
  max-height: 130px;
  overflow: hidden;
}
.hasposter dd img{
  width: 100%;
  display: block;
}
.listbox-top a {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 10px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-top:hover a {
  display: block;
}
.listbox-top a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 45%;
  /*margin-top: -10px;*/
}
.listbox-item {
  width: 100%;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.listbox-item dl {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.listbox-item dl dt {
  position: absolute;
  right: 70px;
  left: 0;
  font-size: 14px;
  line-height: 20px;
}
.listbox-item dl dd {
  width: 60px;
  height: 60px;
  float: right;
  background: #eee;
}
.listbox-item dl dd img{
  width: 100%;
}
.listbox-itembox {
  position: relative;
}
.listbox-itembox a{
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-itembox:hover a {
  display: block;
}
.listbox-itembox a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 30%;
  /*margin-top: -10px;*/
}
.list-box .control span {
  float: left;
  font-size: 13px;
}
.list-box .control{
  margin-top: 10px;
  text-align: right;
  line-height: 20px;
}
.list-box .control a{
  color: #409EFF;
  float: right;
  margin-left: 10px;
  font-size: 13px;
}
.list-box .control a.colorred {
  color: #e74a59;
}

.paBox{
  max-width: 240px;
}
.patop {
  border: 1px solid #eee;
  padding: 10px;
  position: relative;
}
.imgbox{
  background: #eee;
  width: 100%;
  min-height: 120px;
  max-height: 120px;
  overflow: hidden;
  position: relative;
}
.imgbox img{
  max-width: 100%;
  max-height: 100%;
}
.imgbox p{
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.2);
}
.imgbox p span{
  display: block;
  padding: 10px;
  color: #fff;
  left: 0;
  bottom: 0;
  position: absolute;
  font-size: 14px;
  line-height: 18px;
  max-height: 36px;
  overflow: hidden;
}
.pamask{
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid #409EFF;
}
.palist:hover .patopedit {
  display: block;
}
.patopedit {
  position: absolute;
  width: 100%;
  background: rgba(0,0,0,.8);
  left: 0;
  bottom: 0;
  padding: 10px 0;
  display: none;
}
.patopedit i{
  color: #fff;
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.palist {
  position: relative;
  border: 1px solid #eee;
  /*margin-top: -1px;*/
  padding: 10px;
  height: auto;
  height: 60px;
}
.palist dl dd{
  width: 60px;
  height: 60px;
  background: #eee;
  float: right;
  overflow: hidden;
}
.palist dl dd img{
  max-width: 100%;
  max-height: 100%;
}
.palist dl dt{
  position: absolute;
  left: 10px;
  top: 10px;
  height: 60px;
  line-height: 60px;
  overflow: hidden;
}
.paAdd {
  cursor: pointer;
  border: 1px dashed #eee;
  max-width: 238px;
  text-align: center;
  padding: 20px 0;
  border-top: none;
}
.paAdd i{
  font-size: 30px;
}

.local_text {
  word-break: break-all;
}

.contentinput {
  width: 50%;
  float: left;
  /*height: 300px;*/
}
#contentinput {
  /*height: 300px;*/
}
.previewbox {
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
  border: 1px solid #dcdfe6;
  border-left: none;
  padding: 50px 10px 10px;
  line-height: 20px;
  font-size: 14px;
  border-radius: 0 5px 5px 0;
  overflow: auto;
  letter-spacing: 0px;
  font-family: Roboto,Helvetica Neue,"PingFang SC","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
.tips {
  position: absolute;
  left: 100px;
  top: 120px;
  font-size: 12px;
  color: #ccc;
  line-height: 20px;
  width: 200px;
}
.title {
  width: 438px;
  position: absolute;
  top: 1px;
  left: 1px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #ecf8ff;
  /*color: #fff;*/
  border-radius: 5px 5px 0 0;
}
.title2 {
  left: 440px;
  width: 439px;
  border-radius: 0 5px 0 0;
}
</style>
